import React from 'react';
import { NavigationLinks } from '@sky-tv-group/shared';
import { Footer } from '@sky-tv-group/components';

export function FooterPage(links: NavigationLinks) {
  return <Footer links={links} />;
}
